export default "__VITE_ASSET__B0DUBWzl__"